import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { defaultSettings } from '@hooks/useSettings';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  messageType: string;
}

export const useTriggerBatchNotification = () => {
  return useMutation({
    mutationFn: async ({ batchId, messageType }: HookProps) => {
      await request(
        {
          path: `admin/trigger-batch-notification`,
          method: 'POST',
          authenticate: true,
          dataObject: { batchId, messageType },
          baseUrl: `${defaultSettings.apiUrl?.replace('/api/v1', '')}/customs-simulator`,
        },
        true,
      );
    },
    onSuccess: () => {
      toast.success('Simulator notification triggered!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error triggering simulator notification!');
    },
  });
};
